export enum StationTechnicalModeEnum {
    ON,
    OFF,
}
